import request from "./httpService";
const LOCATION_ENDPOINT = '/location';

const addLocation = (location) => {
    return request({
        method: "POST",
        url: `${LOCATION_ENDPOINT}/new`,
        data: location,
    });
}

const updateLocation = (location, id) => {
    return request({
        method: "PUT",
        url: `${LOCATION_ENDPOINT}/${id}`,
        data: location,
    });
}

const getLocations = () => {
    return request({
        method: "GET",
        url: `${LOCATION_ENDPOINT}`
    });
}

const getById = (id) => {
    return request({
        method: "GET",
        url: `${LOCATION_ENDPOINT}/${id}`
    });
}

const getWithLimit = (from, to, filters, sortBy, signal) => {
    return request({
        method: "GET",
        url: `${LOCATION_ENDPOINT}/withlimit/${from}/${to}`,
        params: {filters: filters, sortBy: sortBy},
        signal: signal
    });
}

const deleteLocation = (rowids) => {
    return request({
        method: "DELETE",
        url: `${LOCATION_ENDPOINT}`,
        params: {rowid: rowids}
    });
};

export const LocationService = {
    addLocation,
    updateLocation,
    getLocations,
    getById,
    getWithLimit,
    deleteLocation
};